    <div class="surface-card p-3 border-round" [ngClass]="getColorClass(singleCard)">
      <div class="flex justify-content-between">
        <div class="flex flex-column">
          <span class="block font-bold mb-3">{{ singleCard.name }}</span>
          <div class="flex align-items-center">
            <div class="flex align-items-center justify-content-center" [ngClass]="getDarkenColorClass(singleCard) + ' border-round item-icon'">
              <i class="{{ singleCard.iconName }} text-xl" [ngClass]="getDarkenColorClass(singleCard)"></i>
            </div>
            <div class="ml-2">
              <span class="text-sm">{{getTotalText(singleCard)}}</span>
              <div class="text-900 font-bold text-xl">
                {{ singleCard.count }}
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-content-center">
        <em class="pi pi-external-link black-color cursor-pointer" (click)="loadMyQueues(singleCard.name)"></em>
      </div>
      </div>
    </div>
